export default {"src":"/_next/static/media/star.b1bf6dc5.svg","height":18,"width":19};